/* eslint-disable import/no-default-export */
export default {
  'ClearIconButton.title': 'Clear',
  'CloseButton.title': 'Close',
  'GlAlert.closeButtonTitle': 'Dismiss',
  'GlBanner.closeButtonTitle': 'Dismiss',
  'GlBreadcrumb.showMoreLabel': 'Show more breadcrumbs',
  'GlBroadcastMessage.closeButtonTitle': 'Dismiss',
  'GlCollapsibleListbox.srOnlyResultsLabel': null,
  'GlDatepicker.monthLabel': 'Month',
  'GlDatepicker.yearLabel': 'Year',
  'GlKeysetPagination.navigationLabel': 'Pagination',
  'GlKeysetPagination.nextText': 'Next',
  'GlKeysetPagination.prevText': 'Previous',
  'GlModal.closeButtonTitle': 'Close',
  'GlPagination.labelFirstPage': 'Go to first page',
  'GlPagination.labelLastPage': 'Go to last page',
  'GlPagination.labelNextPage': 'Go to next page',
  'GlPagination.labelPage': 'Go to page %{page}',
  'GlPagination.labelPrevPage': 'Go to previous page',
  'GlPagination.nav': 'Pagination',
  'GlPagination.nextText': 'Next',
  'GlPagination.prevText': 'Previous',
  'GlProgressBar.ariaLabel': 'Progress bar',
  'GlSearchBoxByType.clearButtonTitle': 'Clear',
  'GlSearchBoxByType.input.placeholder': 'Search',
  'GlSorting.sortAscending': 'Sort direction: ascending',
  'GlSorting.sortDescending': 'Sort direction: descending',
  'GlToken.closeButtonTitle': 'Remove',
};
